module.exports = __webpack_public_path__ + "static/media/thumb1.f387b1cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/Hotel/components/VipRoom/images/thumb1.jpg
// module id = 442
// module chunks = 0